/* eslint-disable no-param-reassign */
export default {
  ready() {
    this.listenTo(this, 'tr-grid-todo-row:click', this.handleRowClick.bind(this));

    this.listenTo(document, {
      keydown: (event) => {
        if (event.key === 'Shift' || event.keyCode === 16) {
          this.classList.add('text-unselectable');
        } else if (window.tower.metaKey(event) && event.keyCode === 67) {
          this.handleBatchCopyRows();
        }
      },
      keyup: (event) => {
        if (event.key === 'Shift' || event.keyCode === 16) {
          this.classList.remove('text-unselectable');
        }
      },
    });
  },

  handleRowClick(event) {
    const row = event.target;
    const { originalEvent } = event.detail;
    const { shiftKey } = originalEvent;
    const metaKey = originalEvent.ctrlKey || originalEvent.metaKey;

    if (!this.batchOperationBar || (!shiftKey && !metaKey)) {
      this.selectRow(row);

      if (this.slideOpened || !event.target.editing) {
        this.hideBatchOperationBar();
        this.openRowDetail(row);
      }

      return;
    }

    if (!event.target.editing) {
      if (metaKey) {
        this.selectRowWithMetaKey(row);
      } else if (shiftKey) {
        this.selectRowWithShiftKey(row);
      }
    }
  },

  selectRow(row) {
    this.selectedRows.splice(0).forEach((selectedRow) => {
      selectedRow.selected = false;
    });

    if (row.selectable()) {
      row.selected = true;
      this.selectedRows.push(row);
    }
  },

  selectRowWithMetaKey(row) {
    const selectedRowIndex = this.selectedRows.indexOf(row);

    if (row.selected) {
      row.selected = false;
      if (selectedRowIndex !== -1) this.selectedRows.splice(selectedRowIndex, 1);
    } else if (row.selectable()) {
      row.selected = true;
      if (selectedRowIndex === -1) this.selectedRows.push(row);
    }

    if (this.slidePage.opened) {
      this.slidePage.close();
    }

    if (this.selectedRows.length) {
      this.showBatchOperationBar();
    } else {
      this.hideBatchOperationBar();
    }
  },

  selectRowWithShiftKey(row) {
    const rows = Array.from(this.querySelectorAll('tr-grid-todo-row'));
    const firstRowIndex = rows.indexOf(this.selectedRows[0]);
    const currentRowIndex = rows.indexOf(row);
    const start = currentRowIndex < firstRowIndex ? currentRowIndex : firstRowIndex;
    const end = currentRowIndex < firstRowIndex ? firstRowIndex : currentRowIndex;

    const selectableRows = rows.slice(start, end + 1);
    if (selectableRows.length === 0) selectableRows.push(row);

    this.selectedRows.filter(r => selectableRows.indexOf(r) === -1)
      .forEach((selectedRow) => {
        const rowIndex = this.selectedRows.indexOf(selectedRow);
        if (rowIndex !== -1) this.selectedRows.splice(rowIndex, 1);

        selectedRow.selected = false;
      });

    selectableRows.forEach((selectableRow) => {
      if (this.selectedRows.indexOf(selectableRow) !== -1) return;

      if (selectableRow.selectable()) {
        selectableRow.selected = true;
        this.selectedRows.push(selectableRow);
      }
    });

    if (this.slidePage.opened) {
      this.slidePage.close();
    }

    if (this.selectedRows.length) {
      this.showBatchOperationBar();
    }
  },

  handleBatchCopyRows() {
    if (this.batchOperation) this.initBatchCopyData();
  },

  showBatchOperationBar() {
    this.batchOperation = true;
    if (this.batchOperationBar) {
      const selectedGuids = this.selectedRows.map(selectedRow => selectedRow.guid);
      this.batchOperationBar.selectedGuids = selectedGuids;
    }
  },

  hideBatchOperationBar() {
    this.batchOperation = false;
    if (this.batchOperationBar) {
      this.batchOperationBar.selectedGuids = [];
    }
  },

  initBatchCopyData() {
    let urls = '';
    this.selectedRows.forEach((selectedRow) => {
      const title = selectedRow.querySelector('tr-grid-todo-title-cell .todo-content-shadow .todo-rest').innerHTML;
      urls += `${title} \r\n`;
    });
    const textArea = document.querySelector('.trick-batch-copy-textarea');
    if (textArea) {
      textArea.value = urls;
      textArea.select();
      document.execCommand('copy');
      textArea.value = '';
    }
  },
};
